<template>
	<c-dialog ref="dialog" title="打印模板管理" enable-flex width="1000" height="600" button-name="关闭" :cancel-button="false">
		<c-tab-list ref="tabList" :tabs="tabList" :immediate="false" type="border-tab" @change="tabHandle"></c-tab-list>
		<!--内置打印-->
		<div v-if="currentTab==1" key="1" class="flex-grow flex">
			<div class="flex-column flex-grow">
				<m-operate style="border: none; background: none;">
					<c-button color="main" prepend-icon="tf-add" @click="editHandle()">添加模板</c-button>
				</m-operate>
				<c-table height="grow" :data="templateList" @rowClick="clickHandle">
					<c-table-column
						label="模板名称"
						name="template_name"
						width="250"
					>
						<template #default="{data}">
							<span v-if="data.is_sys_template==2" style="color: #55a532">【系统】</span>
							<span v-else style="color: #0D6EFE">【自定义】</span>
							{{data.template_name}}
						</template>
					</c-table-column>

					<c-table-column
						label="创建时间"
						name="create_date"
						width="180"
					></c-table-column>

					<c-table-column
						label="操作"
						type="button"
						width="160"
					>
						<template #default="{data}">
							<c-table-button v-if="data.saas_id != 0" icon="tf-edit" @click="editHandle(data)">编辑</c-table-button>
							<c-table-button icon="tf-copy" @click="editHandle(data, true)">复制</c-table-button>
							<c-table-button v-if="data.saas_id != 0" icon="tf-trash" @click="deleteHandle(data)">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</div>
			<div class="preview">
				<p class="preview-title">模板效果预览</p>
				<div v-html="htmlTempContent" class="preview-content"></div>
			</div>
		</div>

		<!--Excel打印-->
		<div v-if="currentTab == 2" key="2" class="flex-grow flex-column">
			<div class="flex-column flex-grow">
				<div class="import-steps">
					<p>· 可通过下载系统模板，根据需要自行调整Excel模板格式；</p>
					<p>· 最多存在10个自定义Excel模板，上传的模板文件大小不超过1MB，支持格式为 .xlsx</p>
				</div>
				<m-operate>
					<c-button color="main" prepend-icon="tf-add" @click="uploadHandle">上传模板</c-button>
				</m-operate>
				<c-table height="grow" :data="templateList">
					<c-table-column
						label="模板名称"
						name="template_name"
						width="350"
					>
						<template #default="{data}">
							<span v-if="data.is_sys_template==2" style="color: #55a532">【系统】</span>
							<span v-else style="color: #0D6EFE">【自定义】</span>
							{{data.template_name}}
						</template>
					</c-table-column>

					<c-table-column
						label="创建时间"
						name="create_date"
						width="140"
					></c-table-column>

					<c-table-column
						label="操作"
						type="button"
						width="120"
					>
						<template #default="{data}">
							<c-table-button @click="downloadHandle(data)">下载</c-table-button>
							<c-table-button v-if="data.saas_id != 0" icon="tf-trash" @click="deleteHandle(data)">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</div>
		</div>

		<!--Excel导出-->
		<div v-if="currentTab == 3" key="3" class="flex-grow flex-column">
			<div class="flex-column flex-grow">
				<div class="import-steps">
					<p>· 可通过下载系统模板，根据需要自行调整Excel模板格式；
						<span v-if="exportReadmeUrl">Excel中所支持的参数信息见<c-link @click="window.open(exportReadmeUrl)">《导出模板参数》</c-link></span>
					</p>
					<p>· 最多存在10个自定义Excel模板，上传的模板文件大小不超过1MB，支持格式为 .xlsx</p>
				</div>
				<m-operate>
					<c-button color="main" prepend-icon="tf-add" @click="uploadHandle">上传模板</c-button>
				</m-operate>
				<c-table height="grow" :data="templateList">
					<c-table-column
						label="模板名称"
						name="template_name"
						width="350"
					>
						<template #default="{data}">
							<span v-if="data.is_sys_template==2" style="color: #55a532">【系统】</span>
							<span v-else style="color: #0D6EFE">【自定义】</span>
							{{data.template_name}}
						</template>
					</c-table-column>

					<c-table-column
						label="创建时间"
						name="create_date"
						width="140"
					></c-table-column>

					<c-table-column
						label="操作"
						type="button"
						width="120"
					>
						<template #default="{data}">
							<c-table-button @click="downloadHandle(data)">下载</c-table-button>
							<c-table-button v-if="data.saas_id != 0" icon="tf-trash" @click="deleteHandle(data)">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</div>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		name: 'templateManage',

		props: {
			workType: [Number, String],
			print: String,
			export: String
		},

		data() {
			return {
				currentTab: 1,
				htmlTempContent: '',
				templateList: []
			}
		},

		computed: {
			tabList() {
				let list = [];
				if (this.print && this.auth(this.print)) {
					if (![1,'27'].includes(this.workType.toString())) {
						list.push({'value': 1, 'name': '内置打印模板'});
					}
					if (!['1','27'].includes(this.workType.toString())) {
						list.push({'value': 2, 'name': 'Excel打印模板'});
					}
				}

				if (this.export && this.auth(this.export)) {
					list.push({'value': 3, 'name': 'Excel导出模板'});
				}
				return list;
			},

			templateCount() {
				return this.templateList.filter(item => item.is_sys_template == 1).length;
			},

			printReadmeUrl() {
				return {

                }[this.workType];
			},

			exportReadmeUrl() {
				return {

				}[this.workType];
			}
		},
		
		methods: {
			open() {
				this.$refs.tabList.changeIndex(0);
				this.$refs.dialog.open({
					title: `【${this.getSys().crumbList[this.getSys().crumbList.length - 1]}】模板管理`
				});
			},

			tabHandle(tab) {
				this.currentTab = tab.value;
				this.templateList = [];
				this.loadTemplate();
			},

			loadTemplate() {
				this.htmlTempContent = '';
				this.request({
					url: '/export/template/list',
					data: {
						template_type: this.currentTab,
						work_type: this.workType
					},
					success: data => {
						this.templateList = data;
					}
				});
			},

			async clickHandle({data}) {
				this.htmlTempContent = await this.templatePreview(data.template_content, true);
			},

			editHandle(data = {}, copy) {
				this.globalDialog('printTemplateEdit', {
					data: Object.assign(data, {
						copy,
						workType: this.workType
					})
				}, this.loadTemplate)
			},

			uploadHandle() {
				if (this.templateCount >= 10) {
					this.$message({
						message: '最多只能上传10个Excel模板'
					});
					return;
				}

				this.$upload({
					type: 'xlsx',
					loading: true,
					success: data => {
						this.request({
							url:'/export/template/add',
							data: {
								template_type: this.currentTab,
								work_type: this.workType,
								template_url: data[0].path
							},
							success: () => {
								this.loadTemplate();
							}
						});
					}
				});
			},

			downloadHandle(data) {
				var index = data.template_url.lastIndexOf('.');
				var fineName = data.template_name + data.template_url.substring(index,data.template_url.length);
				this.download({
					fileName:fineName,
					url: data.template_url,
					loading: {
						message: '文件下载中...'
					}
				});
			},

			deleteHandle(data) {
				this.$confirm({
					message: '确定要删除该模板吗？',
					resolve: () => {
						this.request({
							url: '/export/template/remove',
							data: {
								id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '模板已删除'
								});
								this.loadTemplate();
							}
						})
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.preview {
		position: relative;
		box-sizing: border-box;
		min-width: 400px;
		width: 360px;
		border-left: 1px solid var(--table-border);
		overflow: auto;
		background: #F8F8F8;

		&-title {
			position: sticky;
			left: 0;
			top: 0;
			line-height: 44px;
			font-size: 16px;
			font-weight: bold;
			text-align: center;	
			background: #F8F8F8;
		}

		&-content {
			display: inline-block;
		}

		>>> .print-page {
			box-sizing: border-box;
			margin: 0 20px 20px;
			overflow: hidden;
			font-size: 10pt;
			background: #fff;
			
			table {
				width: 100%;
				max-width: 100%;
				border: .2mm solid #000;

				td {
					vertical-align: middle;
					border: .2mm solid #000;
					padding: 1.5mm;
					word-break: break-all;

					img {
						vertical-align: middle;
					}
				}
			}
		}
	}

	.import-steps {
		padding: 10px 20px;
		margin: 10px;
		background-color: #F8F8F8;

		p {
			padding: 4px 0;
			line-height: 20px;
			color: #666;
		}
	}
</style>